// Checkers pieces: turned discs with a brushed-gold rim — charcoal for Black,
// ivory for White. A king is two discs stacked (crowned) with a gold top ring.
// Shared geometry / materials. Swap for GLBs later with the same props
// (origin at the bottom centre, ~52 mm across).

import React from 'react';
import * as THREE from 'three';
import { noRaycast } from '../../VR/vrUi';

const R = 0.026, H = 0.011;
let disc: THREE.BufferGeometry | null = null;
let rim: THREE.BufferGeometry | null = null;
let inner: THREE.BufferGeometry | null = null;
const geos = () => {
  if (!disc) {
    disc = new THREE.CylinderGeometry(R, R * 0.97, H, 24);
    disc.translate(0, H / 2, 0);
    rim = new THREE.TorusGeometry(R * 0.78, 0.0016, 6, 24);
    rim.rotateX(Math.PI / 2);
    inner = new THREE.TorusGeometry(R * 0.45, 0.0014, 6, 20);
    inner.rotateX(Math.PI / 2);
  }
  return { disc: disc!, rim: rim!, inner: inner! };
};
const mats: Record<string, THREE.Material> = {};
const mat = (k: 'dark' | 'light' | 'gold') => (mats[k] ??= k === 'dark'
  ? new THREE.MeshStandardMaterial({ color: '#25292d', roughness: 0.38, metalness: 0.15 })
  : k === 'light' ? new THREE.MeshStandardMaterial({ color: '#efe4cc', roughness: 0.42 })
  : new THREE.MeshStandardMaterial({ color: '#b8862e', roughness: 0.32, metalness: 0.75 }));

/** kind: 'man' | 'king'; side 0 = Black, 1 = White. */
export function CheckerPiece({ kind, side }: { kind: string; side: 0 | 1 }) {
  const g = geos();
  const m = mat(side === 0 ? 'dark' : 'light');
  const gold = mat('gold');
  const layers = kind === 'king' ? 2 : 1;
  return (
    <group>
      {Array.from({ length: layers }, (_, i) => (
        <group key={i} position={[0, i * H, 0]}>
          <mesh geometry={g.disc} material={m} castShadow raycast={noRaycast as any} />
          <mesh geometry={g.rim} material={gold} position={[0, H + 0.0002, 0]} raycast={noRaycast as any} />
        </group>
      ))}
      {kind === 'king' && <mesh geometry={g.inner} material={gold} position={[0, 2 * H + 0.0003, 0]} raycast={noRaycast as any} />}
    </group>
  );
}

export default CheckerPiece;
